import React, { useState } from 'react'
import { snakeCase } from 'lodash'
import { Field } from 'redux-form'
import { required } from 'views/Users/validate'

import { SelectWrapper } from 'components'

const isValueLeaf = (val) => typeof val === 'string'

const NestedDropdowns = ({ node, onFinalSelect, path = ['UserTask'] }) => {
  const [selectedKey, setSelectedKey] = useState(null)

  const hasOnlyLeafOptions = Object.keys(node).every((key) => isValueLeaf(node[key]))

  const options = Object.keys(node).map((key) => ({
    label: key.replace(/_/g, ' ').toUpperCase(),
    value: key
  }))

  const currentFieldName = `${path.map(snakeCase).join('_') || 'root'}_select`

  const handleChange = (_, selected) => {
    let finalSymbol

    const baseParts = path.map((segment, index) => {
      return index === 0 ? segment : snakeCase(segment)
    })

    const currentBasePath = baseParts.join('::')

    if (hasOnlyLeafOptions) {
      const selectedItems = Array.isArray(selected)
        ? selected.map((item) => (item && typeof item === 'object' ? item.value : item)).filter(Boolean)
        : []
      setSelectedKey(selectedItems.length > 0 ? selectedItems[0] : null)

      if (selectedItems.length > 0) {
        const finalPart =
          selectedItems.length === 1
            ? snakeCase(selectedItems[0])
            : `[${selectedItems.map(snakeCase).sort().join(', ')}]`
        finalSymbol = `${currentBasePath}::${finalPart}`
      }
    } else {
      const selectedValue = selected && typeof selected === 'object' && 'value' in selected ? selected.value : selected

      setSelectedKey(selectedValue)

      const selectedNodeValue = node[selectedValue]
      if (isValueLeaf(selectedNodeValue)) {
        finalSymbol = `${currentBasePath}::${snakeCase(selectedValue)}`
      }
    }

    onFinalSelect?.(finalSymbol)
  }

  return (
    <div>
      <Field
        name={currentFieldName}
        component={SelectWrapper}
        options={options}
        onChange={handleChange}
        label="Select"
        validate={[required]}
        isMulti={hasOnlyLeafOptions}
        inputProps={{ placeholder: 'Select an option' }}
      />

      {selectedKey && typeof node[selectedKey] === 'object' && (
        <NestedDropdowns node={node[selectedKey]} path={[...path, selectedKey]} onFinalSelect={onFinalSelect} />
      )}
    </div>
  )
}

export default NestedDropdowns
